import { createSelector } from 'reselect'

const getLeaseProfile = state => state.leaseProfile

export const selectAvailableLeaseProfileFilters = createSelector(
  [getLeaseProfile],
  leaseProfile => leaseProfile.availableProfiles,
)

export const selectLeaseProfile = createSelector([getLeaseProfile], leaseProfile => leaseProfile.activeProfile)
